const ListingFilter = ({
    listingId = '',
    name = '',
} = {}) => ({
    listingId: String(listingId),
    name: String(name),
});

const AccountFilter = ({
    customerId = '',
    billingAccountName = '',
    zillowAccountId = '',
} = {}) => ({
    customerId: String(customerId),
    billingAccountName: String(billingAccountName),
    zillowAccountId: String(zillowAccountId),
});

const OverviewFilter = ({
    listings = [],
    rocketshipAccounts = [],
} = {}) => ({
    listings: listings.map(listing => new ListingFilter(listing)),
    rocketshipAccounts: rocketshipAccounts.map(account => new AccountFilter(account)),
});

export default OverviewFilter;
